export default {"src":"/_next/static/media/cart-bucket.f61ca991.svg","height":16,"width":16};